import { types } from 'mobx-state-tree'

const model = types
  .model('Expandable', {
    expanded: types.boolean,
  })

export default model
